export default __webpack_public_path__ + "static/Overseas_Student_Enrolment_Form-cef352044c8e5a6402e5e435cd404c82.pdf";